import { graphql } from "react-relay";
import { Environment, RecordSourceSelectorProxy } from "relay-runtime";

import {
  commitMutationPromiseNormalized,
  createMutation,
  MutationInput,
} from "coral-framework/lib/relay";

import { UpdateUserBadgesMutation as MutationTypes } from "coral-admin/__generated__/UpdateUserBadgesMutation.graphql";

let clientMutationId = 0;

const UpdateUserBadgesMutation = createMutation(
  "updateUserBadges",
  (environment: Environment, input: MutationInput<MutationTypes>) => {
    return commitMutationPromiseNormalized<MutationTypes>(environment, {
      mutation: graphql`
        mutation UpdateUserBadgesMutation(
          $input: UpdateUserBadgesOnSiteInput!
        ) {
          updateUserBadgesOnSite(input: $input) {
            modifiedCount
            matchedCount
            clientMutationId
          }
        }
      `,
      variables: {
        input: {
          ...input,
          clientMutationId: (clientMutationId++).toString(),
        },
      },
      updater: (store: RecordSourceSelectorProxy) => {
        const user = store.get(input.userID);
        if (!user) {
          return;
        }
        const siteUsernames = user.getLinkedRecords("siteUsername");
        if (!siteUsernames) {
          return;
        }

        const siteUsername = siteUsernames.find(
          (su) => su && su.getValue("siteID") === input.siteID
        );
        if (!siteUsername) {
          return;
        }

        // Get existing badges and filter out old user-specific badges
        const existingBadges = siteUsername.getLinkedRecords("badges") || [];
        const siteLevelBadges = existingBadges.filter(
          (badge) => badge && !badge.getValue("isUserSpecific")
        );

        if (input.badges.length === 0) {
          // Remove user-specific badges, keep only site-level badges
          siteUsername.setLinkedRecords(siteLevelBadges, "badges");
        } else {
          // Create new user-specific badge records
          const userBadgeRecords = input.badges
            .filter((badge) => badge && badge.badge && badge.badge.trim())
            .map((badge) => {
              const recordId = `client:badge:${input.userID}:${input.siteID}:${badge.badge}`;
              let badgeRecord = store.get(recordId);

              if (!badgeRecord) {
                badgeRecord = store.create(recordId, "BadgeRule");
              }

              badgeRecord.setValue(badge.badge, "badge");
              badgeRecord.setValue(
                badge.isUserSpecific || true,
                "isUserSpecific"
              );
              return badgeRecord;
            });
          // Set badges: site-level badges + new user-specific badges
          siteUsername.setLinkedRecords(
            [...siteLevelBadges, ...userBadgeRecords],
            "badges"
          );
        }
      },
    });
  }
);

export default UpdateUserBadgesMutation;
